import { createReducer } from '@reduxjs/toolkit';
import {
  clearApplicantDetailAction,
  clearApplicantsAction,
  downloadApplicantCvErrorAction,
  patchApplicantLocationsAction,
  patchApplicantStatusAction,
  removeApplicantAction,
  setApplicantActionErrorAction,
  setApplicantActionLoadingAction,
  setApplicantDetailAction,
  setApplicantDetailErrorAction,
  setApplicantDetailLoadingAction,
  setApplicantsAction,
  setApplicantsErrorAction,
  setApplicantsLoadingAction,
  setPromoteSuccessMessageAction,
} from 'store/actions/job-applicant-actions';
import { IJobApplicantsState } from 'types/employee/IJobApplicant';

const initialState: IJobApplicantsState = {
  applicants: [],
  loading: false,
  error: null,
  numberOfApplicants: null,
  totalPages: null,
  currentPage: 0,
  applicantDetail: null,
  applicantDetailLoading: false,
  applicantDetailError: null,
  applicantActionLoading: false,
  applicantActionError: null,
  cvDownloadError: false,
  promoteSuccessMessage: null,
};

const jobApplicantReducer = createReducer(initialState, builder =>
  builder
    .addCase(setApplicantsAction, (state, action) => {
      const isFirstPage = action.payload.pageIndex <= 1;
      return {
        ...state,
        applicants: isFirstPage ? action.payload.items : [...state.applicants, ...action.payload.items],
        numberOfApplicants: action.payload.numberOfResults,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.pageIndex,
      };
    })
    .addCase(setApplicantsLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setApplicantsErrorAction, (state, action) => ({ ...state, error: action.payload }))
    .addCase(clearApplicantsAction, () => initialState)
    .addCase(setApplicantDetailAction, (state, action) => ({ ...state, applicantDetail: action.payload }))
    .addCase(setApplicantDetailLoadingAction, (state, action) => ({ ...state, applicantDetailLoading: action.payload }))
    .addCase(setApplicantDetailErrorAction, (state, action) => ({ ...state, applicantDetailError: action.payload }))
    .addCase(clearApplicantDetailAction, state => ({
      ...state,
      applicantDetail: null,
      applicantDetailError: null,
      applicantActionError: null,
      cvDownloadError: false,
    }))
    .addCase(setApplicantActionLoadingAction, (state, action) => ({ ...state, applicantActionLoading: action.payload }))
    .addCase(setApplicantActionErrorAction, (state, action) => ({ ...state, applicantActionError: action.payload }))
    .addCase(patchApplicantStatusAction, (state, action) => ({
      ...state,
      applicants: state.applicants.map(applicant =>
        applicant.id === action.payload.id ? { ...applicant, status: action.payload.status } : applicant,
      ),
      applicantDetail:
        state.applicantDetail?.id === action.payload.id
          ? { ...state.applicantDetail, status: action.payload.status }
          : state.applicantDetail,
    }))
    .addCase(downloadApplicantCvErrorAction, (state, action) => ({ ...state, cvDownloadError: action.payload }))
    .addCase(patchApplicantLocationsAction, (state, action) => ({
      ...state,
      applicantDetail:
        state.applicantDetail?.id === action.payload.id
          ? { ...state.applicantDetail, locationIds: action.payload.locationIds }
          : state.applicantDetail,
    }))
    .addCase(removeApplicantAction, (state, action) => ({
      ...state,
      applicants: state.applicants.filter(applicant => applicant.id !== action.payload.id),
    }))
    .addCase(setPromoteSuccessMessageAction, (state, action) => ({ ...state, promoteSuccessMessage: action.payload })),
);

export default jobApplicantReducer;
